import { LogoBlueClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';

export default function InvoiceHead() {
  const t = useTranslations();
  return (
    <div>
      <div className="invoice__paper__from_to">
        <LogoBlueClipArt className="mb-8 w-full scale-[1]" />
        <h1 className="invoice__paper__to align-right !text-[36px] !font-semibold !text-black">
          {t('billing.invoice')}
        </h1>
      </div>
    </div>
  );
}
